const MAX_PROD_LOG_CHARS = 500

const truncateProdMessage = (msg: string): string =>
  msg.length > MAX_PROD_LOG_CHARS ? `${msg.slice(0, MAX_PROD_LOG_CHARS)}…` : msg

/**
 * Logs no browser: em produção evita despejar objetos de erro completos
 * (podem conter detalhes de API, SQL ou PII em mensagens encadeadas).
 */
export function logClientError(scope: string, err: unknown): void {
  if (import.meta.env.DEV) {
    console.error(scope, err)
    return
  }
  const msg =
    err instanceof Error
      ? err.message
      : typeof err === 'string'
        ? err
        : 'Erro desconhecido'
  console.error(scope, truncateProdMessage(msg))
}

export function logClientWarn(scope: string, err: unknown): void {
  if (import.meta.env.DEV) {
    console.warn(scope, err)
    return
  }
  const msg =
    err instanceof Error
      ? err.message
      : typeof err === 'string'
        ? err
        : 'Aviso'
  console.warn(scope, truncateProdMessage(msg))
}
